import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Клиент: /page → /page/ (кроме корня).
 * Cloudflare Pages для …/index.html канонизирует URL со слэшем; без этого
 * клиентский strip давал петлю 308 ↔ navigate.
 */
export function TrailingSlashNormalize() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;
    if (pathname !== "/" && !pathname.endsWith("/")) {
      navigate(`${pathname}/${search}${hash}`, { replace: true });
    }
  }, [location, navigate]);

  return null;
}
